import { IPdfTemplate } from '../types/pdfTemplateTypes';

export function filterTemplatesForSelection(templates: IPdfTemplate[], selectionCount: number): IPdfTemplate[] {
  const wantsMulti = selectionCount >= 2;
  return (templates || []).filter((template) => {
    const mode = (template as any).templateMode || 'single';
    const maxProducts = Number((template as any).maxProducts || 0);
    if (wantsMulti) {
      return mode === 'multi' && (maxProducts === 0 || selectionCount <= maxProducts);
    }
    return mode !== 'multi';
  });
}
